import React from 'react';
import MediaContainer from 'shared/components/MediaContainer/MediaContainer';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { ICastingRoleAttributes } from 'shared/interfaces/ICastingRole';
import { useStyles } from '../Role.styles';
import { Grid } from '@material-ui/core';

type Props = {
  data: ICastingRoleAttributes | undefined;
};

const RoleInformation: React.FC<Props> = ({ data }) => {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div>
        <div className={classes.flexMiniColumnContainer}>
          <CustomTypography fontSize={13} fontWeight={600}>
            Paying Role: {data?.paying_role}
          </CustomTypography>
          {data?.rate_summary ? (
            <CustomTypography fontSize={13}>{data?.rate_summary || '–'}</CustomTypography>
          ) : (
            <React.Fragment />
          )}
        </div>
      </div>
      <div>
        <div className={classes.flexMiniColumnContainer}>
          <CustomTypography fontSize={13} fontWeight={600}>
            Additional Role Rate Information:
          </CustomTypography>
          <CustomTypography fontSize={13}>{data?.rate_information || '–'}</CustomTypography>
        </div>
      </div>
      <div>
        <div className={classes.flexMiniColumnContainer}>
          <CustomTypography fontSize={13} fontWeight={600}>
            Days included in the above fee:
          </CustomTypography>
          <CustomTypography fontSize={13}>{data?.activity_dates?.days_included || '–'}</CustomTypography>
        </div>
      </div>
      <div>
        <div className={classes.flexMiniColumnContainer}>
          <CustomTypography fontSize={13} fontWeight={600}>
            Role Description:
          </CustomTypography>
          <CustomTypography fontSize={13} style={{ whiteSpace: 'break-spaces' }}>
            {data?.talent_description || '–'}
            {/* change for ST revision */}
            {/* {data?.agents_clients_description || '–'} */}
          </CustomTypography>
        </div>
      </div>
      <div>
        <div className={classes.miniRow}>
          <CustomTypography fontSize={13} fontWeight={600}>
            Role Age Range:
          </CustomTypography>
          <CustomTypography fontSize={13}>
            {`${data?.age_range_from ? data.age_range_from : 0} – ${data?.age_range_to ? data.age_range_to : 0}`}
          </CustomTypography>
        </div>
      </div>
      <div className={classes.miniRow}>
        <CustomTypography fontSize={13} fontWeight={600}>
          Role Genders:
        </CustomTypography>
        <CustomTypography fontSize={13}>
          {data?.genders && data?.genders.length > 0 ? (
            <React.Fragment>
              {data?.genders.map((i, _) => (
                <React.Fragment>{data?.genders.length === _ + 1 ? i : `${i}, `}</React.Fragment>
              ))}
            </React.Fragment>
          ) : (
            '–'
          )}
        </CustomTypography>
      </div>
      <div className={classes.miniRow}>
        <CustomTypography fontSize={13} fontWeight={600}>
          Role Ethnic Appearance:
        </CustomTypography>
        <div className={classes.miniRow}>
          <CustomTypography fontSize={13}>
            {data && data?.ethnic_appearance?.length > 0
              ? data?.ethnic_appearance.map((i, _) => (
                  <React.Fragment>{data?.ethnic_appearance.length === _ + 1 ? i : `${i}, `}</React.Fragment>
                ))
              : '–'}
          </CustomTypography>
        </div>
      </div>
      {/* <div className={classes.miniRow}>
      <CustomTypography fontSize={13}>
        Sides:
      </CustomTypography>
      {data && data?.project.medium_attachments.length > 0 ? (
        <React.Fragment>
          {data?.project.medium_attachments.length > 0 ? (
            <Grid container style={{ gap: 10 }}>
              {data?.project.medium_attachments.map((i) => (
                <MediaContainer key={i.id} media={i} mode={'lightModeOnly'} />
              ))}
            </Grid>
          ) : (
            <React.Fragment />
          )}
        </React.Fragment>
      ) : (
        <CustomTypography fontSize={13}>
          No Sides Available
        </CustomTypography>
      )}
    </div> */}
    </React.Fragment>
  );
};

export default RoleInformation;
